export const environment = {
  production: true,
  hmr: false,
  apiUrl: 'http://localhost:4000',
  kuberAiUrl: 'https://honest-caring-dev.up.railway.app',
  firebase: {
    apiKey: "AIzaSyCQclQOVfQPTjDsipOggAjGYya_3MBVwtA",
    authDomain: "intense-baton-327115.firebaseapp.com"
  }
};